import { useMemo } from 'react';

import { useIsAchievementsAdminEnabled } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useAchievementsAdminPageSettings: UseMainUIFeatureSettings<'achievementsAdminPage'> = (options) => {
  const achievementsAdminPageOverrides = options?.overrides?.achievementsAdminPage;

  const isAchievementsAdminEnabled = useIsAchievementsAdminEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: isAchievementsAdminEnabled,
      ...achievementsAdminPageOverrides,
    }),
    [achievementsAdminPageOverrides, isAchievementsAdminEnabled]
  );
};
